<template>
  <div class="expandable-block" :class="{open: isOpen}">
    <button class="expandable-block__label text-body-1" aria-label="Show more" @click="toggle">
      <span class="flex-1 text-body-1 fw-semi-bold">
        {{title}}
      </span>
      <span class="icon icon-chevron-down"></span>
    </button>
    <div class="expandable-block__body text-body-2 color-dark-grey">
      {{text}}
    </div>
  </div>
</template>

<script setup lang="ts">
const {
  title,
  text,
  openByDefault
} = defineProps({
  title: {type: String},
  text: {type: String},
  openByDefault: {type: Boolean, default: false}
})
let isOpen = ref(false)

onMounted(() => {
  isOpen.value = openByDefault
})

function toggle() {
  isOpen.value = !isOpen.value
}

</script>

<style lang="scss" scoped>
.expandable-block {
  margin-bottom: 12px;
  background-color: var(--light-grey);
  border-radius: 8px;
  .expandable-block__label {
    padding: 16px;
    width: 100%;
    display: flex;
    text-align: left;
    .icon {
      font-size: 24px;
      transition: transform .2s;
    }
  }
  &.open {
    background-color: var(--blue-highlight);
    .expandable-block__label .icon {
      transform: rotate(-180deg);
    }
    .expandable-block__body {
      display: block;
    }
  }
  .expandable-block__body {
    display: none;
    padding: 0 16px 16px;
  }
}
</style>
